import { useEffect, useState } from 'react';
import { useSearchParams } from '@/compat/react-router-dom';
import { partnerPortalAuthService } from '@/api/services';
import {
  commitPreparedAttribution,
  preparePartnerAttribution,
  readPartnerAttribution,
  trackingCodeFromSearch,
} from '@/utils/partnerAttribution';

const usePartnerAttributionState = (partnerSlug = '') => {
  const [searchParams] = useSearchParams();
  const search = String(searchParams?.toString?.() || '');
  const [attribution, setAttribution] = useState(() => (
    typeof window === 'undefined' ? null : readPartnerAttribution()
  ));

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const next = await preparePartnerAttribution({
          partnerSlug,
          search,
          resolvePartner: async (slug) => {
            const res = await partnerPortalAuthService.resolvePartnerSlug(slug);
            return res?.data?.data || null;
          },
        });
        if (cancelled) return;
        setAttribution(commitPreparedAttribution({
          existing: readPartnerAttribution(),
          next,
          partnerSlug,
          search,
        }));
      } catch {
        if (!cancelled) setAttribution(readPartnerAttribution());
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [partnerSlug, search]);

  const urlCode = trackingCodeFromSearch(search, { allowAliases: Boolean(partnerSlug) });
  const trackingCode = urlCode || String(attribution?.tracking_code || '').trim();
  return { attribution, trackingCode };
};

export default usePartnerAttributionState;
